"use strict";
import { getChromeRuntime } from "utilities/src/chrome/chrome";
import { TRUSTED_CHROME_EXTENSION_IDS } from "utilities/src/environment/extensionId";
import { logger } from "utilities/src/logger/logger";
import { isExtension, isInterface } from "utilities/src/platform";
export function isTestEnv() {
  return !!process.env.JEST_WORKER_ID || process.env.NODE_ENV === "test" || !!(typeof window !== "undefined" && window.Cypress) || !!isPlaywrightEnv();
}
export function isPlaywrightEnv() {
  return typeof window !== "undefined" && typeof window.__playwright__binding__ !== "undefined";
}
export function isDevEnv() {
  if (isInterface) {
    return process.env.NODE_ENV === "development";
  } else if (isExtension) {
    const chromeRuntime = getChromeRuntime();
    if (!chromeRuntime) {
      console.warn(
        "Avoid using `isDevEnv()` inside the injected script. Use `__DEV__` instead. `chrome.runtime` is only available when the injected script is running inside a trusted site (`app.uniswap.org`). This helper only works reliably when running the app locally but not when publishing the Dev build."
      );
      return __DEV__;
    }
    return __DEV__ || chromeRuntime.id === TRUSTED_CHROME_EXTENSION_IDS.dev || chromeRuntime.id === TRUSTED_CHROME_EXTENSION_IDS.local;
  } else if (isTestEnv()) {
    return false;
  } else {
    throw createAndLogError("isDevEnv");
  }
}
export function isBetaEnv() {
  if (isInterface) {
    return Boolean(process.env.REACT_APP_STAGING);
  } else if (isExtension) {
    const chromeRuntime = getChromeRuntime();
    if (!chromeRuntime) {
      console.warn(
        "Avoid using `isBetaEnv()` inside the injected script. `chrome.runtime` is only available when the injected script is running inside a trusted site (`app.uniswap.org`). This helper always returns `false` when running inside the injected script on other websites."
      );
      return false;
    }
    return chromeRuntime.id === TRUSTED_CHROME_EXTENSION_IDS.beta;
  } else if (isTestEnv()) {
    return false;
  } else {
    throw createAndLogError("isBetaEnv");
  }
}
export function isProdEnv() {
  if (isInterface) {
    return process.env.NODE_ENV === "production" && !isBetaEnv();
  } else if (isExtension) {
    const chromeRuntime = getChromeRuntime();
    if (!chromeRuntime) {
      console.warn(
        "Avoid using `isProdEnv()` inside the injected script. `chrome.runtime` is only available when the injected script is running inside a trusted site (`app.uniswap.org`). This helper always returns `true` when running inside the injected script on other websites."
      );
      return true;
    }
    return chromeRuntime.id === TRUSTED_CHROME_EXTENSION_IDS.prod;
  } else if (isTestEnv()) {
    return false;
  } else {
    throw createAndLogError("isProdEnv");
  }
}
function createAndLogError(funcName) {
  const e = new Error("Unsupported app environment that failed all checks");
  logger.error(e, {
    tags: {
      file: "utilities/src/environment/env.web.ts",
      function: funcName
    }
  });
  return e;
}
export function isRNDev() {
  return false;
}
